module.exports = __webpack_public_path__ + "img/SL-M-260-280.ee24fa5a.svg";